// extracted by mini-css-extract-plugin
module.exports = {"viewPdfBlock":"ViewPdf_viewPdfBlock__uDqjU","zoomBtn":"ViewPdf_zoomBtn__emICw","docTitle":"ViewPdf_docTitle__OBGtg","countDocs":"ViewPdf_countDocs__x0EuH"};